// Section 20 and 21 (stream G): the Ledger's store action. After a win the player may continue
// in sandbox: the sim keeps counting steady years toward a longer target (api continueInSandbox,
// steadyTarget) and the season flow resumes at phase 2.
import { continueInSandbox } from '../../sim/api';
import { withBoundary } from '../boundary';
import { requireGame, requireStatus } from '../guards';
import { enterDeciding } from '../session';
import { patchUi } from '../state';

export const continueSandbox = withBoundary((): void => {
  requireStatus('ended', 'reporting');
  const next = continueInSandbox(requireGame());
  patchUi({ overlay: null });
  enterDeciding(next);
});
